<template>
  <v-col>
    <v-row :justify="admin ? 'space-between' : 'end'" class="mx-0 mb-1">
      <delete-button v-if="admin" quiet headline="Delete Program page?" :ondelete="deletePage" />
      <save-button :onsave="savePage" />
    </v-row>
    <v-row>
      <v-col>
        <ProgramPageInfo />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import ProgramPageInfo from "@/modules/program_pages/components/ProgramPageInfo";

export default {
  components: {
    ProgramPageInfo,
  },
  computed: {
    admin() {
      return this.$store.getters["isAdmin"];
    },
  },
  methods: {
    deletePage() {
      return this.$store
        .dispatch("ProgramPageStore/deleteProgramPage")
        .then(() => {
          this.$root.$success("Deleted Program page");
          this.$router.push({
            name: "database_view",
            params: {
              view: "program_pages",
              sub: "ALL",
            },
          });
        })
        .catch((err) => this.$root.$error(err));
    },
    savePage() {
      return this.$store
        .dispatch("ProgramPageStore/updateProgramPage")
        .then(() => this.$root.$success("Updated Program page"))
        .catch((err) => this.$root.$error(err));
    },
  },
  beforeDestroy() {
    if (this.$store.getters["ProgramPageStore/hasChanges"]) {
      this.savePage();
    }
  },
};
</script>
